import React from "react";
import Link from "gatsby-link";
import Logo from "./Logo";

const Flower = () => (
    <g id="flower-container">
      <g id="copy-flower" transform="rotate(18) translate(4, -110)">
        <desc>Ένα αντίγραφο του λουλουδιού ως διακοσμιτικό στοιχείο</desc>
        <defs>
          <radialGradient
            id="orange-gradient"
            cx="444.9221"
            cy="389.7568"
            r="149.3198"
            gradientTransform="matrix(1 0 0 -1 102.3999 547.1602)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style={{ stopColor: "#ffc14f" }} />
            <stop offset="0.5" style={{ stopColor: "#ffbd42" }} />
            <stop offset="0.6665" style={{ stopColor: "#fcb837" }} />
            <stop offset="1" style={{ stopColor: "#f2a718" }} />
          </radialGradient>
        </defs>
        <path
          id="petal-vref-dupli"
          fill="url(#orange-gradient)"
          opacity="0"
          d="M689.1,75c55.6,262-141.6,229.9-160.3,226.3c-0.9-0.2-1.4-0.3-1.4-0.3l-47.6-8    c3.3-4.7,6.3-9.8,8.899-15.2c23-48.2,4.2-105.1-41.8-127c-11.6-5.5-23.8-8.3-35.899-8.6l-15.301-36.5C506-89,689.1,75,689.1,75z"
        />
        <defs>
          <radialGradient
            id="pink-gradient"
            cx="312.1536"
            cy="126.5103"
            r="147.9312"
            gradientTransform="matrix(1 0 0 -1 102.3999 547.1602)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style={{ stopColor: "#ff9bcc" }} />
            <stop offset="0.5" style={{ stopColor: "#ff8cc5" }} />
            <stop offset="0.6665" style={{ stopColor: "#ff7bbd" }} />
            <stop offset="1" style={{ stopColor: "#f45da8" }} />
          </radialGradient>
        </defs>

        <path
          id="petal-nip-dupli"
          fill="url(#pink-gradient)"
          opacity="0"
          d="M528.8,301.7C671,464,420.9,557.8,420.9,557.8C159.6,489.8,286.5,324.4,293.4,315.7    c0.2-0.2,0.301-0.4,0.301-0.4l28.1-31.8c8.7,17.9,23,32.9,42.1,42C404.8,345,453.5,330.4,480,293.1l47.6,8    c0,0,0.5,0.101,1.4,0.301L528.8,301.7z"
        />
        <defs>
          <radialGradient
            id="purple-gradient"
            cx="155.2717"
            cy="382.6543"
            r="154.2948"
            gradientTransform="matrix(1 0 0 -1 102.3999 547.1602)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style={{ stopColor: "#e172f9" }} />
            <stop offset="0.5" style={{ stopColor: "#d44ff2" }} />
            <stop offset="0.6665" style={{ stopColor: "#cc34ee" }} />
            <stop offset="1" style={{ stopColor: "#cb1ff2" }} />
          </radialGradient>
        </defs>

        <path
          id="petal-paid-dupli"
          fill="url(#purple-gradient)"
          opacity="0"
          d="M395.699,105.8L411,142.3c-36.2-0.9-71.9,20.1-89,56.2c-13.5,28.3-12.601,59.6-0.2,85.1l-28.1,31.8    c0,0-0.101,0.1-0.301,0.399L293,315.5C85.8,355,104.8,106.8,104.8,106.8C277-112.1,395.699,105.8,395.699,105.8z"
        />

        <path
          id="center-dupli"
          fill="url(#yellow-gradient)"
          opacity="0"
          d="M446.9,150.9c46.101,21.9,64.8,78.8,41.8,127c-2.6,5.4-5.6,10.5-8.899,15.2    c-26.5,37.301-75.2,51.9-116.101,32.4c-19-9-33.399-24.1-42.1-42c-12.4-25.4-13.3-56.8,0.2-85.1c17.2-36.1,52.899-57.1,89-56.2    C423.199,142.6,435.3,145.3,446.9,150.9z"
        />
      </g>
      <g id="real-flower" role="navigation">
        <g id="base">
          <g id="Layer_2" transform="translate(5, 421) scale(2) rotate(-20)">
            <g id="Layer_1-2">
              <path
                d="M205.91,183.54s7.38,11.41,17.45,0c-.67-14.09,0-45,0-45s.67-18.79,8.72-20.8l.67-12.08s-6,3.35-9.39-3.36c.67-6.71-4-47-4-47H212l-.67,5.37-9.4-11.41h-8.72s12.08,10.07,12.75,16.11c-.67,6.71,3.35,37.58,3.35,37.58S214,164.08,205.91,183.54Z"
                fill="#006837"
                stroke="#000"
                strokeMiterlimit="10"
              />
              <g transform="translate(35, 40) scale(0.85)">
                <path
                  d="M219.33,55.35s22.15,75.17,91.95,85.91c28.18-2,41.61-2.69,54.36,0a198.47,198.47,0,0,0,21.47-5.37s2-9.69-22.81-16.93c-12.08-8.57-16.78-19.31-38.26-29.38C316.65,79.51,285.1,48.64,219.33,55.35Z"
                  fill="#39b54a"
                  stroke="#000"
                  strokeMiterlimit="10"
                />
                <path
                  d="M219.33,55.35s64.47,29.53,83.91,51c19.45,5.37,23.47,3.35,45.62,15.44,18.12,7.38,38.25,14.09,38.25,14.09"
                  fill="none"
                  stroke="#8cc63f"
                  strokeMiterlimit="10"
                />
                <text
                  transform="rotate(23)"
                  xmlSpace="preserve"
                  textAnchor="middle"
                  fontSize="15"
                  id="text-phone"
                  y="-20"
                  x="310"
                  strokeLinecap="null"
                  strokeLinejoin="null"
                  strokeDasharray="null"
                  strokeWidth="0"
                  stroke="#000000"
                  fill="#ffffff"
                >
                  Τηλ: 2751067012
                </text>
              </g>
            </g>
          </g>
        </g>

        <g
          id="flower-head"
          style={{ transform: "rotate(18deg) translate(4px, -110px)" }}
        >
          <Link to="/vrefikos">
            <g id="petal-vref" className="petal-container">
              <title>Σελίδα Βρεφικoύ Σταθμού</title>
              <desc>Σελίδα βρεφικoύ σταθμού</desc>
              <defs>
                <radialGradient
                  id="SVGID_1_"
                  cx="444.9221"
                  cy="389.7568"
                  r="149.3198"
                  gradientTransform="matrix(1 0 0 -1 102.3999 547.1602)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" style={{ stopColor: "#E2907A" }} />
                  <stop offset="0.5" style={{ stopColor: "#D76250" }} />
                  <stop offset="0.6665" style={{ stopColor: "#C95C4D" }} />
                  <stop offset="1" style={{ stopColor: "#B25148" }} />
                </radialGradient>
              </defs>

              <path
                className="petal"
                fill="url(#SVGID_1_)"
                d="M689.1,75c55.6,262-141.6,229.9-160.3,226.3c-0.9-0.2-1.4-0.3-1.4-0.3l-47.6-8    c3.3-4.7,6.3-9.8,8.899-15.2c23-48.2,4.2-105.1-41.8-127c-11.6-5.5-23.8-8.3-35.899-8.6l-15.301-36.5C506-89,689.1,75,689.1,75z"
              />
              <path
                className="pulse pulse-1"
                fill="none"
                d="M689.1,75c55.6,262-141.6,229.9-160.3,226.3c-0.9-0.2-1.4-0.3-1.4-0.3l-47.6-8    c3.3-4.7,6.3-9.8,8.899-15.2c23-48.2,4.2-105.1-41.8-127c-11.6-5.5-23.8-8.3-35.899-8.6l-15.301-36.5C506-89,689.1,75,689.1,75z"
              />
              <text
                transform="translate(75, -69) rotate(-15)"
                xmlSpace="preserve"
                textAnchor="middle"
                fontSize="24"
                id="text-vref"
                y="345"
                x="433.51563"
                strokeLinecap="null"
                strokeLinejoin="null"
                strokeDasharray="null"
                strokeWidth="0"
                stroke="#000000"
                fill="#ffffff"
              >
                Βρεφικός Σταθμός
              </text>
            </g>
          </Link>

          <Link to="/nhpiagwgeio">
            <g id="petal-nip" className="petal-container">
              <title>Σελίδα Νηπιαγωγείου</title>            
              <desc>Σελίδα Νηπιαγωγείου</desc>
              <defs>
                <radialGradient
                  id="SVGID_2_"
                  cx="312.1536"
                  cy="126.5103"
                  r="147.9312"
                  gradientTransform="matrix(1 0 0 -1 102.3999 547.1602)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" style={{ stopColor: "#E2907A" }} />
                  <stop offset="0.5" style={{ stopColor: "#D76250" }} />
                  <stop offset="0.6665" style={{ stopColor: "#C95C4D" }} />
                  <stop offset="1" style={{ stopColor: "#B25148" }} />
                </radialGradient>
              </defs>

              <path
                className="petal"
                fill="url(#SVGID_2_)"
                d="M528.8,301.7C671,464,420.9,557.8,420.9,557.8C159.6,489.8,286.5,324.4,293.4,315.7    c0.2-0.2,0.301-0.4,0.301-0.4l28.1-31.8c8.7,17.9,23,32.9,42.1,42C404.8,345,453.5,330.4,480,293.1l47.6,8    c0,0,0.5,0.101,1.4,0.301L528.8,301.7z"
              />
              <path
                className="pulse pulse-2"
                fill="none"
                d="M528.8,301.7C671,464,420.9,557.8,420.9,557.8C159.6,489.8,286.5,324.4,293.4,315.7    c0.2-0.2,0.301-0.4,0.301-0.4l28.1-31.8c8.7,17.9,23,32.9,42.1,42C404.8,345,453.5,330.4,480,293.1l47.6,8    c0,0,0.5,0.101,1.4,0.301L528.8,301.7z"
              />
              <text
                transform="translate(211, 224) rotate(-13)"
                xmlSpace="preserve"
                textAnchor="middle"
                fontSize="24"
                id="text-nip"
                y="244"
                x="157"
                strokeLinecap="null"
                strokeLinejoin="null"
                strokeDasharray="null"
                strokeWidth="0"
                stroke="#000000"
                fill="#ffffff"
              >
                Νηπιαγωγείο
              </text>
            </g>
          </Link>

          <Link to="/paidikos">
            <g id="petal-paid" className="petal-container">
              <title>Σελίδα Παιδικού Σταθμού</title>
              <desc>Σελίδα Παιδικού Σταθμού</desc>
              <defs>
                <radialGradient
                  id="SVGID_4_"
                  cx="155.2717"
                  cy="382.6543"
                  r="154.2948"
                  gradientTransform="matrix(1 0 0 -1 102.3999 547.1602)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" style={{ stopColor: "#E2907A" }} />
                  <stop offset="0.5" style={{ stopColor: "#D76250" }} />
                  <stop offset="0.6665" style={{ stopColor: "#C95C4D" }} />
                  <stop offset="1" style={{ stopColor: "#B25148" }} />
                </radialGradient>
              </defs>

              <path
                className="petal"
                fill="url(#SVGID_4_)"
                d="M395.699,105.8L411,142.3c-36.2-0.9-71.9,20.1-89,56.2c-13.5,28.3-12.601,59.6-0.2,85.1l-28.1,31.8    c0,0-0.101,0.1-0.301,0.399L293,315.5C85.8,355,104.8,106.8,104.8,106.8C277-112.1,395.699,105.8,395.699,105.8z"
              />
              <path
                className="pulse pulse-3"
                fill="none"
                d="M395.699,105.8L411,142.3c-36.2-0.9-71.9,20.1-89,56.2c-13.5,28.3-12.601,59.6-0.2,85.1l-28.1,31.8    c0,0-0.101,0.1-0.301,0.399L293,315.5C85.8,355,104.8,106.8,104.8,106.8C277-112.1,395.699,105.8,395.699,105.8z"
              />
              <text
                transform="rotate(-19) translate(-209, 141)"
                xmlSpace="preserve"
                textAnchor="middle"
                fontSize="24"
                y="86"
                x="391.51563"
                id="text-paid"
                strokeLinecap="null"
                strokeLinejoin="null"
                strokeDasharray="null"
                strokeWidth="0"
                stroke="#000000"
                fill="#ffffff"
              >
                Παιδικός Σταθμός
              </text>
            </g>
          </Link>

          <Link to="/epikoinwnia">
            <g id="center-container">
              <title>Στοιχεία επικοινωνίας</title>
              <desc>Όνειρο - Στοιχεία επικοινωνίας</desc>
              <defs>
                <radialGradient
                  id="yellow-gradient"
                  cx="302.8616"
                  cy="308.998"
                  r="94.6423"
                  gradientTransform="matrix(1 0 0 -1 102.3999 547.1602)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" style={{ stopColor: "#FAF3DC" }} />
                  <stop offset="0" style={{ stopColor: "#FAECC1" }} />
                  <stop offset="0" style={{ stopColor: "#FADE8A" }} />
                  <stop offset="0.5506" style={{ stopColor: "#F4C844" }} />
                  <stop offset="0.685" style={{ stopColor: "#E8BE46" }} />
                  <stop offset="1" style={{ stopColor: "#D1AA4A" }} />
                </radialGradient>
              </defs>

              <path
                id="center"
                fill="url(#yellow-gradient)"
                d="M446.9,150.9c46.101,21.9,64.8,78.8,41.8,127c-2.6,5.4-5.6,10.5-8.899,15.2    c-26.5,37.301-75.2,51.9-116.101,32.4c-19-9-33.399-24.1-42.1-42c-12.4-25.4-13.3-56.8,0.2-85.1c17.2-36.1,52.899-57.1,89-56.2    C423.199,142.6,435.3,145.3,446.9,150.9z"
              />
              <path
                className="pulse pulse-4"
                fill="none"
                d="M446.9,150.9c46.101,21.9,64.8,78.8,41.8,127c-2.6,5.4-5.6,10.5-8.899,15.2    c-26.5,37.301-75.2,51.9-116.101,32.4c-19-9-33.399-24.1-42.1-42c-12.4-25.4-13.3-56.8,0.2-85.1c17.2-36.1,52.899-57.1,89-56.2    C423.199,142.6,435.3,145.3,446.9,150.9z"
              />
              <g 
                transform="scale(.4) translate(800, 590) rotate(-15)"
              >
                <Logo />
              </g>
            </g>
          </Link>
        </g>
      </g>
    </g>
);

export default Flower;


// WEBPACK FOOTER //
// ./src/components/Flower.js